// extracted by mini-css-extract-plugin
export default {"container":"CommunityInfoForm_container__-56NE"};